import { useMutation, QueryOptions } from "react-query";
import { verifyDevicesAgents } from "./devices-agents-service";

export const useVerifyDevicesAgents = (config?: QueryOptions) => {
  return useMutation((data: any) => verifyDevicesAgents(data), config);
};
